import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { commonPostPutApi } from "../../../redux/reducers/commonApiSlice";
import { showConfirmAlert } from "../../components-react/ReactAlert";
import CloseSubmitBtn from "../../common-components/custom-comps/CloseSubmitBtn";
import SelectDropdown from "../../components-react/SelectDropdown";

const SendyListForm = ({
  isEdit,
  rowData,
  closeModal,
  userInfoData,
  callFunction,
}) => {
  const dispatch = useDispatch();
  const { postPutLoading } = useSelector((state) => state.common);

  // Debug logging
  console.log("SendyListForm - isEdit:", isEdit);
  console.log("SendyListForm - rowData:", rowData);

  const forminitials = {
    listName: isEdit ? rowData?.name || rowData?.list_name || "" : "",
    type: isEdit ? rowData?.type || "public" : "public",
    optin: isEdit ? rowData?.optin || "single" : "single",
    tags:
      isEdit && rowData?.tags
        ? Array.isArray(rowData.tags)
          ? rowData.tags.join(", ")
          : String(rowData.tags || "")
        : "",
    description: isEdit ? rowData?.description || "" : "",
  };

  console.log("SendyListForm - forminitials:", forminitials);
  const [formValues, setFormValues] = useState(forminitials);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);

  const onChangeInput = (e) => {
    setIsSubmit(false);
    const { name, value } = e.target;
    setFormValues((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const onChangeDropdown = (value, name) => {
    setIsSubmit(false);
    setFormValues((prev) => ({
      ...prev,
      [name]: value?.value || value,
    }));
  };

  const handleSubmitForm = async (payload) => {
    console.log("handleSubmitForm called with payload:", payload);
    try {
      const method = isEdit ? "PUT" : "POST";
      const endpoint = isEdit
        ? `/listmonk/lists/update/${rowData?.id || rowData?.uid}`
        : "/listmonk/create_lists";
      const token = userInfoData?.token || "";

      console.log("Making API call:", { method, endpoint, payload, token });

      const result = await dispatch(
        commonPostPutApi({ method, endpoint, payload, token })
      );

      console.log("API result:", result);

      if (result?.payload?.status) {
        setIsSubmit(false);
        setFormValues(forminitials);

        callFunction();
        closeModal();
        toast.success(
          result?.payload?.message ||
            `List ${isEdit ? "updated" : "created"} successfully!`
        );
      } else {
        const errorMessage =
          result?.payload?.data ||
          result?.payload?.message ||
          result?.error?.message;
        console.error("API error:", errorMessage);
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error processing list:", error);
      toast.error(`Failed to ${isEdit ? "update" : "create"} list`);
    }
  };

  const validateListForm = (values) => {
    const errors = {};

    if (!values.listName?.trim()) {
      errors.listName = "List name is required!";
    }

    if (!values.type) {
      errors.type = "Type is required!";
    }

    if (!values.optin) {
      errors.optin = "Opt-in is required!";
    }

    return errors;
  };

  const onSumitForm = (e) => {
    e.preventDefault();
    console.log("Form submitted with values:", formValues);
    const errors = validateListForm(formValues);
    console.log("Validation errors:", errors);
    setFormErrors(errors);
    setIsSubmit(true);
  };

  useEffect(() => {
    console.log(
      "useEffect triggered - isSubmit:",
      isSubmit,
      "formErrors:",
      formErrors
    );
    if (isSubmit && Object.keys(formErrors)?.length === 0) {
      // Convert tags string to array for API submission
      let tagsArray = [];
      if (formValues.tags) {
        if (typeof formValues.tags === "string") {
          tagsArray = formValues.tags
            .split(",")
            .map((tag) => tag.trim())
            .filter((tag) => tag);
        } else if (Array.isArray(formValues.tags)) {
          tagsArray = formValues.tags.filter((tag) => tag && tag.trim());
        }
      }

      const userData = {
        name: formValues.listName,
        type: formValues.type,
        optin: formValues.optin,
        tags: tagsArray,
        description: formValues.description,
      };

      console.log("Submitting userData:", userData);

      const handleConfirm = async () => {
        handleSubmitForm(userData);
      };

      showConfirmAlert(
        handleConfirm,
        `${isEdit ? "Update" : "Add"} List`,
        "Edit Form",
        "Submit Form"
      );
    }
  }, [isSubmit, formErrors]);

  console.log("formValues=> ", formValues);

  return (
    <div className="form-container">
      <form className="formContainer">
        <div className="formInputsGrid twoGridSystem">
          <div className="formInputBox">
            <label htmlFor="listName" className={`formInputLabel`}>
              List Name <span className="required">*</span>
            </label>

            <input
              type="text"
              placeholder="Enter List Name"
              className={`formInput ${formErrors?.listName ? "formError" : ""}`}
              name="listName"
              value={formValues.listName}
              onChange={onChangeInput}
            />
          </div>

          <div className="formInputBox">
            <label htmlFor="type" className={`formInputLabel`}>
              Type <span className="required">*</span>
            </label>

            <div
              className={`commonWrapper ${formErrors?.type ? "formError" : ""}`}
            >
              <SelectDropdown
                options={[
                  { label: "Public", value: "public" },
                  { label: "Private", value: "private" },
                ]}
                selectedOption={
                  formValues.type
                    ? {
                        label:
                          formValues.type === "public" ? "Public" : "Private",
                        value: formValues.type,
                      }
                    : null
                }
                setSelectedOption={(selectedValue) =>
                  onChangeDropdown(selectedValue, "type")
                }
                name="Type"
              />
            </div>
          </div>

          <div className="formInputBox">
            <label htmlFor="optin" className={`formInputLabel`}>
              Opt-in <span className="required">*</span>
            </label>

            <div
              className={`commonWrapper ${
                formErrors?.optin ? "formError" : ""
              }`}
            >
              <SelectDropdown
                options={[
                  { label: "Single", value: "single" },
                  { label: "Double", value: "double" },
                ]}
                selectedOption={
                  formValues.optin
                    ? {
                        label:
                          formValues.optin === "single" ? "Single" : "Double",
                        value: formValues.optin,
                      }
                    : null
                }
                setSelectedOption={(selectedValue) =>
                  onChangeDropdown(selectedValue, "optin")
                }
                name="Opt-in"
              />
            </div>
          </div>

          <div className="formInputBox">
            <label htmlFor="tags" className={`formInputLabel`}>
              Tags <span className="text-muted">(comma separated)</span>
            </label>

            <input
              type="text"
              placeholder="e.g. gym, promotion, summer, discount"
              className={`formInput ${formErrors?.tags ? "formError" : ""}`}
              name="tags"
              value={formValues.tags}
              onChange={onChangeInput}
            />
          </div>

          <div className={`formInputBox span2`}>
            <label htmlFor="description" className={`formInputLabel`}>
              Description
            </label>

            <textarea
              placeholder="Enter description"
              className={`formInput ${
                formErrors?.description ? "formError" : ""
              }`}
              name="description"
              value={formValues.description}
              onChange={onChangeInput}
              rows="3"
            />
          </div>
        </div>

        <CloseSubmitBtn
          closeLabel="Cancel"
          submitLabel={isEdit ? "Update" : "Submit"}
          onClose={closeModal}
          onSubmit={onSumitForm}
          isLoading={postPutLoading}
        />
      </form>
    </div>
  );
};

export default SendyListForm;
